// src/pages/Contact.jsx
import React from 'react';
import { Box, Container, Typography, TextField, Button } from '@mui/material';

const Contact = () => {
  return (
    <Container maxWidth="sm" sx={{ my: 4, py: 4 }}>
      <Typography variant="h4" align="center" gutterBottom sx={{ fontWeight: 700 }}>
        Contact Us
      </Typography>
      <Typography variant="body1" align="center" sx={{ mb: 3 }}>
        We'd love to hear from you! Please fill out the form below and we'll get back to you as soon as possible.
      </Typography>
      <Box
        component="form"
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: 2,
        }}
        noValidate
        autoComplete="off"
      >
        <TextField label="Name" variant="outlined" fullWidth />
        <TextField label="Email" variant="outlined" type="email" fullWidth />
        <TextField
          label="Message"
          variant="outlined"
          fullWidth
          multiline
          rows={4}
        />
        <Button variant="contained" color="primary">
          Submit
        </Button>
      </Box>
    </Container>
  );
};

export default Contact;
